import * as React from 'react'
import { Link } from 'react-router-dom'

import { Button, ButtonComponentProps } from '../../../../components/button'
import { IconNameType } from '../../../../components/icon'
import { useETFHoldingsQuery } from '../hooks'
import { ETFHoldingsDialogType, ETFHoldingsDialogViewType, ETFHoldingsQuery, ETFHoldingsWidgetViewType } from '../types'
import { getRounding } from '../utils'

export function NavButton({ to, ...props }: ButtonComponentProps<'a'> & { to: Record<string, any> }) {
  return <Button {...props} as={Link} to={`?${new URLSearchParams(to)}`} preventScrollReset />
}

interface LinkNavigationProps {
  navType: ETFHoldingsQuery
  query: ReturnType<typeof useETFHoldingsQuery>
  viewTypes: ETFHoldingsWidgetViewType[]
}

interface ButtonNavigationProps {
  navType: 'dialog'
  onNavigationChange: (value: ETFHoldingsDialogType) => void
  viewTypes: ETFHoldingsDialogViewType[]
  active: ETFHoldingsDialogType
}

type NavigationProps = LinkNavigationProps | ButtonNavigationProps

export function Navigation(props: NavigationProps) {
  const { viewTypes, navType } = props

  return (
    <div className="flex items-center space-x-px">
      <label className="mr-1.5 text-2xs text-gray-400">View Holdings as</label>
      {viewTypes.map((item) => {
        const buttonProps = {
          rounding: getRounding(),
          appearance: 'square',
          leftContent: item.icon as IconNameType,
          key: `${navType}-${item.chartType}`,
          theme: 'chipTransparent',
          size: 'small',
        }
        if (navType !== 'dialog') {
          return (
            <NavButton
              {...(buttonProps as ButtonComponentProps<'a'>)}
              key={`${navType}-${item.chartType}`}
              to={{ ...props.query.params, [navType]: item.chartType }}
              active={props.query[navType] === item.chartType}
              data-testid={`etf-holdings-chart-nav-btn-${item.chartType}`}
            />
          )
        }
        return (
          <Button
            {...(buttonProps as ButtonComponentProps)}
            key={`${navType}-${item.chartType}`}
            active={props.active === item.chartType}
            onClick={() => props.onNavigationChange(item.chartType as ETFHoldingsDialogType)}
            data-testid={`etf-holdings-chart-nav-btn-${navType}-${item.chartType}`}
          />
        )
      })}
    </div>
  )
}
